// @flow
import type {
  RequestProductsPayload,
  FlattenedProductResponse,
  Variants,
  StateProducts,
  Favorites,
  FavoritesResponse,
  FavoritesUpdateRequest,
} from '../../sharedTypes';

export const PRODUCTS = {
  REQUEST_PRODUCTS: 'products/request_products',
  RECEIVE_PRODUCTS_RATINGS: 'products/receive_products_ratings',
  FAILED_PRODUCTS_REQUEST: 'products/failed_products/request',
  RECEIVE_PRODUCTS: 'products/receive_products',
  RECEIVE_MORE_PRODUCTS: 'products/receive_more_products',
  RECEIVE_ALL_PRODUCTS: 'products/receive_all_products',
  RECEIVE_MORE_ALL_PRODUCTS: 'products/receive_more_all_products',
  RESET_ALL_PRODUCTS: 'products/reset_all_products',
  RECEIVE_SPONSORED_PRODUCTS: 'products/receive_sponsored_products',
  RECEIVE_CART_PRODUCTS: 'products/receive_cart_products',
  REQUEST_FAVORITES: 'products/request_favorites',
  SET_FAVORITES: 'products/set_favorites',
  REQUEST_TOGGLE_FAVORITE: 'products/request_toggle_favorite',
  RECEIVE_TOGGLED_FAVORITE: 'products/receive_toggled_favorite',
  TOGGLE_SOLDOUT: 'products/toggle_soldout',
  DISPLAY_SPONSORED_POPUP_WARNING: 'products/display_sponsored_popup_warning',
  DISPLAY_REMOVE_GWP_DISQUALIFY_POPUP:
    'products/display_remove_gwp_disqualify_popup',
  DISPLAY_REMOVE_GWP_DOWNGRADE_POPUP:
    'products/display_remove_gwp_downgrade_popup',
  DISPLAY_REMOVE_GWP_OUT_OF_STOCK_POPUP:
    'products/display_remove_gwp_out_of_stock_popup',
  DISPLAY_REMOVE_GWP_WARNING_POPUP: 'products/display_remove_gwp_warning_popup',
  HIDE_SPONSORED_WARNING: 'products/hide_sponsored_warning',
  SET_OVERRIDE_DEFAULT_VARIANT_ID: 'products/set_override_default_variant_id',
  REQUEST_BEST_SELLING_PRODUCTS: 'products/request_best_selling_products',
  RECEIVE_BEST_SELLING_PRODUCTS: 'products/receive_best_selling_products',
  RECEIVE_BEST_SELLING_PRODUCTS_ERROR:
    'products/receive_best_selling_products_error',
  RECEIVE_BEST_SELLING_ALL_PRODUCTS:
    'products/receive_best_selling_all_products',
  REQUEST_PRODUCTS_BY_ID: 'products/request_products_by_id',
  REQUEST_SEARCH_PRODUCTS: 'products/request_search_products',
  RECEIVE_SEARCH_PRODUCTS: 'product/receive_search_products',
  REQUEST_FEATURED_PRODUCTS: 'products/request_featured_products',
  RECEIVE_FEATURED_PRODUCTS: 'products/receive_featured_products',
  RECEIVE_FEATURED_PRODUCTS_ERROR: 'products/receive_featured_products_error',
  REQUEST_PRODUCT_RECOMMENDATIONS: 'products/request_product_recommendations',
  RECEIVE_PRODUCT_RECOMMENDATIONS: 'products/receive_product_recommendations',
  RECEIVE_PRODUCT_RECOMMENDATIONS_ERROR:
    'products/receive_product_recommendations_error',
  RECEIVE_FAVORITE_PRODUCTS: 'products/receive_favorite_products',
  REQUEST_RATING_GRAPH: 'products/request_rating_graph',
  RECEIVE_RATING_GRAPH: 'products/receive_rating_graph_detail',
  REQUEST_HAS_REVIEWED: 'products/request_has_reviewed',
  RECEIVE_HAS_REVIEWED: 'products/received_has_reviewed',
  RECEIVE_SUBSCRIBABLE_PRODUCTS: 'products/receive_subscribable_products',
  RECEIVE_SUBSCRIBABLE_PRODUCTS_ERROR:
    'products/receive_subscribable_products_error',
  REQUEST_FILTERED_PRODUCTS: 'products/request_filtered_products',
  RECEIVE_FILTERED_PRODUCTS: 'products/receive_filtered_products',
  RECEIVE_FILTERED_PRODUCTS_ERROR: 'products/receive_filtered_products_error',
};

export type RequestFavoritesAction = {|
  type: typeof PRODUCTS.REQUEST_FAVORITES,
|};

export type SetFavoritesAction = {|
  type: typeof PRODUCTS.SET_FAVORITES,
  favorites: FavoritesResponse,
|};
export type RequestToggleFavoritesAction = {|
  type: typeof PRODUCTS.REQUEST_TOGGLE_FAVORITE,
  productId: string,
  variantId: string,
  buttonLocation: string,
  isLike: boolean,
  selectedCategoryId: string | null,
  positionLocation: string | null,
  referrerProductId: string | null,
  positionOrder: number | null,
|};

export type RequestProductsAction = {|
  type: typeof PRODUCTS.REQUEST_PRODUCTS,
  payload: RequestProductsPayload,
|};

export type FailedProductsRequestAction = {|
  type: typeof PRODUCTS.FAILED_PRODUCTS_REQUEST,
|};

export type ReceiveProductsAction = {|
  type: typeof PRODUCTS.RECEIVE_PRODUCTS,
  payload: FlattenedProductResponse,
|};

export type ReceiveMoreProductsAction = {|
  type: typeof PRODUCTS.RECEIVE_MORE_PRODUCTS,
  payload: FlattenedProductResponse,
|};

export type ReceiveSponsoredProductsAction = {|
  type: typeof PRODUCTS.RECEIVE_SPONSORED_PRODUCTS,
  payload: FlattenedProductResponse,
|};

export type ReceiveCartProductsAction = {|
  type: typeof PRODUCTS.RECEIVE_CART_PRODUCTS,
  payload: {| variants: Variants, products: StateProducts |},
|};

export type DisplaySponsoredPopupWarningAction = {|
  type: typeof PRODUCTS.DISPLAY_SPONSORED_POPUP_WARNING,
  variantId: string,
|};

export type HideSponsoredWarningAction = {|
  type: typeof PRODUCTS.HIDE_SPONSORED_WARNING,
|};

export type SetOverrideDefaultVariantIdAction = {|
  type: typeof PRODUCTS.SET_OVERRIDE_DEFAULT_VARIANT_ID,
  variantId: string,
|};

export function requestFavorites() {
  return {
    type: PRODUCTS.REQUEST_FAVORITES,
  };
}

export function setFavorites(favorites: Favorites) {
  return {
    type: PRODUCTS.SET_FAVORITES,
    favorites,
  };
}

export function requestToggleFavorite(
  productId: string,
  variantId: string,
  buttonLocation: string,
  isLike: string,
  selectedCategoryId: string | null,
  positionLocation: string,
  referrerProductId: string | null,
  positionOrder: number | null
) {
  return {
    type: PRODUCTS.REQUEST_TOGGLE_FAVORITE,
    productId,
    variantId,
    buttonLocation,
    isLike,
    selectedCategoryId,
    positionLocation,
    referrerProductId,
    positionOrder,
  };
}

export function receiveToggledFavorite(payload: FavoritesUpdateRequest) {
  return {
    type: PRODUCTS.RECEIVE_TOGGLED_FAVORITE,
    payload,
  };
}

export function requestProducts(payload: RequestProductsPayload) {
  return {
    type: PRODUCTS.REQUEST_PRODUCTS,
    payload,
  };
}

export function failedProductsRequest() {
  return {
    type: PRODUCTS.FAILED_PRODUCTS_REQUEST,
  };
}

export function receiveProducts(
  payload: FlattenedProductResponse,
  rateAndReviewFF: boolean
) {
  return {
    type: PRODUCTS.RECEIVE_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveMoreProducts(
  payload: FlattenedProductResponse,
  rateAndReviewFF: boolean
) {
  return {
    type: PRODUCTS.RECEIVE_MORE_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveAllProducts(
  payload: FlattenedProductResponse,
  rateAndReviewFF: boolean
) {
  return {
    type: PRODUCTS.RECEIVE_ALL_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveMoreAllProducts(
  payload: FlattenedProductResponse,
  rateAndReviewFF: boolean
) {
  return {
    type: PRODUCTS.RECEIVE_MORE_ALL_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function resetAllProducts() {
  return {
    type: PRODUCTS.RESET_ALL_PRODUCTS,
  };
}

export function receiveSponsoredProducts(
  payload: FlattenedProductResponse,
  rateAndReviewFF: boolean
) {
  return {
    type: PRODUCTS.RECEIVE_SPONSORED_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveCartProducts(payload: {|
  variants: Variants,
  products: StateProducts,
|}) {
  return {
    type: PRODUCTS.RECEIVE_CART_PRODUCTS,
    payload,
  };
}

export function toggleSoldOut(
  variantId: string,
  isSubscribable: boolean,
  soldOut: boolean
) {
  return {
    type: PRODUCTS.TOGGLE_SOLDOUT,
    variantId,
    isSubscribable,
    soldOut,
  };
}

export function displaySponsoredPopupWarning(variantId: string) {
  return {
    type: PRODUCTS.DISPLAY_SPONSORED_POPUP_WARNING,
    variantId,
  };
}

export function displayRemoveGWPDisqualifyPopup(variantId: string) {
  return {
    type: PRODUCTS.DISPLAY_REMOVE_GWP_DISQUALIFY_POPUP,
    variantId,
  };
}

export function displayRemoveGWPDowngradePopup(variantId: string) {
  return {
    type: PRODUCTS.DISPLAY_REMOVE_GWP_DOWNGRADE_POPUP,
    variantId,
  };
}

export function displayRemoveGWPOutOfStockPopup(variantId: string) {
  return {
    type: PRODUCTS.DISPLAY_REMOVE_GWP_OUT_OF_STOCK_POPUP,
    variantId,
  };
}

export function displayRemoveGWPWarningPopup(variantId: string) {
  return {
    type: PRODUCTS.DISPLAY_REMOVE_GWP_WARNING_POPUP,
    variantId,
  };
}

export function hideSponsoredWarning() {
  return {
    type: PRODUCTS.HIDE_SPONSORED_WARNING,
  };
}

export function setOverrideDefaultVariantId(variantId: string | null) {
  return {
    type: PRODUCTS.SET_OVERRIDE_DEFAULT_VARIANT_ID,
    variantId,
  };
}

export function requestBestSellingProducts(payload: RequestProductsPayload) {
  return {
    type: PRODUCTS.REQUEST_BEST_SELLING_PRODUCTS,
    payload,
  };
}

export function receiveBestSellingProducts(payload, rateAndReviewFF) {
  return {
    type: PRODUCTS.RECEIVE_BEST_SELLING_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveBestSellingAllProducts(payload, rateAndReviewFF) {
  return {
    type: PRODUCTS.RECEIVE_BEST_SELLING_ALL_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveBestSellingProductsError(payload, rateAndReviewFF) {
  return {
    type: PRODUCTS.RECEIVE_BEST_SELLING_PRODUCTS_ERROR,
    payload,
    rateAndReviewFF,
  };
}

export function requestProductsById(
  productIds,
  isAllProducts,
  rateAndReviewFF
) {
  return {
    type: PRODUCTS.REQUEST_PRODUCTS_BY_ID,
    productIds,
    isAllProducts,
    rateAndReviewFF,
  };
}

export function requestSearchProducts(payload) {
  return {
    type: PRODUCTS.REQUEST_SEARCH_PRODUCTS,
    payload,
  };
}

export function receiveSearchProducts(payload, rateAndReviewFF) {
  return {
    type: PRODUCTS.RECEIVE_SEARCH_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function requestFeaturedProducts(selectedCategoryId) {
  return {
    type: PRODUCTS.REQUEST_FEATURED_PRODUCTS,
    selectedCategoryId,
  };
}

export function receiveFeaturedProducts(payload, rateAndReviewFF) {
  return {
    type: PRODUCTS.RECEIVE_FEATURED_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveFeaturedProductsError() {
  return {
    type: PRODUCTS.RECEIVE_FEATURED_PRODUCTS_ERROR,
  };
}

export function receiveProductRatings(productsRatings) {
  return {
    type: PRODUCTS.RECEIVE_PRODUCTS_RATINGS,
    payload: productsRatings,
  };
}

export function requestRatingGraph(payload) {
  return {
    type: PRODUCTS.REQUEST_RATING_GRAPH,
    payload,
  };
}

export function receiveRatingGraph(payload) {
  return {
    type: PRODUCTS.RECEIVE_RATING_GRAPH,
    payload,
  };
}

export function requestProductHasReviewed(payload) {
  return {
    type: PRODUCTS.REQUEST_HAS_REVIEWED,
    payload,
  };
}

export function receiveProductHasReviewed(payload) {
  return {
    type: PRODUCTS.RECEIVE_HAS_REVIEWED,
    payload,
  };
}

export function requestProductRecommendations(productId, campaignType, limit) {
  return {
    type: PRODUCTS.REQUEST_PRODUCT_RECOMMENDATIONS,
    productId,
    campaignType,
    limit,
  };
}

export function receiveProductRecommendations(payload) {
  return {
    type: PRODUCTS.RECEIVE_PRODUCT_RECOMMENDATIONS,
    payload,
  };
}

export function receiveProductRecommendationsError(error) {
  return {
    type: PRODUCTS.RECEIVE_PRODUCT_RECOMMENDATIONS_ERROR,
    error,
  };
}

export function receiveFavoriteProducts(payload, rateAndReviewFF) {
  return {
    type: PRODUCTS.RECEIVE_FAVORITE_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveSubscribableProducts(payload) {
  return {
    type: PRODUCTS.RECEIVE_SUBSCRIBABLE_PRODUCTS,
    payload,
  };
}

export function receiveSubscribableProductsError() {
  return {
    type: PRODUCTS.RECEIVE_SUBSCRIBABLE_PRODUCTS_ERROR,
  };
}

export function requestFilteredProducts(payload) {
  return {
    type: PRODUCTS.REQUEST_FILTERED_PRODUCTS,
    payload,
  };
}

export function receiveFilteredProducts(payload, rateAndReviewFF) {
  return {
    type: PRODUCTS.RECEIVE_FILTERED_PRODUCTS,
    payload,
    rateAndReviewFF,
  };
}

export function receiveFilteredProductsError(payload) {
  return {
    type: PRODUCTS.RECEIVE_FILTERED_ALL_PRODUCTS,
    payload,
  };
}
